var geolocation = require('src/interlock/no-ui/geolocation/geolocation');
var commonValidator = require('src/interlock/no-ui/validation/common');
var zcUtils = require('./zipcode-changer-utils');


var GW_ZIPCODE_CHANGER_CLASS = '.gw-zipcode-changer';
var GW_ZIPCODE_ERROR_MESSAGE_CLASS = '.error-message';
var GW_ERROR = 'error';
var GW_LOADING = 'loading';
var GW_OPEN = 'open';
var ZIP_ERROR_MESSAGES = {
    DEFAULT: 'We don\'t recognize this zip code. Please try again.',
    DIGITS: 'Please enter a 5 digit zip code.'
};

function error($formParent, message) {
    var $errorMessage = $formParent.find(GW_ZIPCODE_ERROR_MESSAGE_CLASS);
    $errorMessage.text(message);
    $formParent.addClass(GW_ERROR);
}

/**
 * Adds event listener to window object with callback which calls _zipCloser function.
 * @private
 */
function _addCloseZipListener() {
    $(document).one('click', function(e) {
        _zipCloser(e);
    });
}

/**
 * This function is to toggle the class open for the zip code changer
 * @param e - event
 * @private
 */
function _zipToggler(e) {
    e.preventDefault();
    e.stopPropagation();
    var $parent = $(e.target).parents(GW_ZIPCODE_CHANGER_CLASS);
    if($parent.hasClass(GW_OPEN)) {
        $parent.removeClass(GW_OPEN);
    } else {
        $parent.addClass(GW_OPEN);
        _addCloseZipListener();
    }
}

/**
 * This function is to remove the class open for the zip code changer.
 * @param e - event
 * @private
 */
function _zipCloser(e) {
    var $zipCodeChangers = $(GW_ZIPCODE_CHANGER_CLASS);
    var $parent = $(e.target).parents(GW_ZIPCODE_CHANGER_CLASS);
    if(!$parent.length) {
        $zipCodeChangers.removeClass(GW_OPEN);
    } else {
        _addCloseZipListener();
    }
}

/**
 * To call geolocation to get the zipcode then populate it in the input field
 * @param $zipInput - jquery dom input field
 * @private
 */
function _geolocation($zipcodeForm, $zipInput) {
    var $formParent = $zipcodeForm.parent();
    $formParent.removeClass(GW_ERROR);
    $formParent.addClass(GW_LOADING);
    var geolocationTimeout;
    geolocationTimeout = setTimeout(function() {
        $formParent.removeClass(GW_LOADING);
    }, 5000);
    geolocation.getLocationByGeoApi()
        .then(function(data) {
            $zipInput.val(data.zipCode);
            clearTimeout(geolocationTimeout);
            $formParent.removeClass(GW_LOADING);
        })
        .catch(function(err) {
            error($zipcodeForm.parent(), err.message);
            clearTimeout(geolocationTimeout);
            $formParent.removeClass(GW_LOADING);
        });
}

/**
 * The submit handler that validates and redirects.
 * @param e - event
 * @private
 */
function _submit(e) {
    e.preventDefault();
    var $formParent = $(e.target).parent();
    var zipInput = e.target.elements['zip'];
    var zipValue = zipInput.value;
    var $zipUpdateButton = $(e.target).find('button');
    $(e.target).data('tracking-value', zipValue);

    $zipUpdateButton.prop('disabled', true);
    $formParent.removeClass(GW_ERROR);

    if(!zipValue) {
        error($formParent, ZIP_ERROR_MESSAGES.DEFAULT);
        $zipUpdateButton.prop('disabled', false);
        return;
    }

    commonValidator.validateZipCode(zipValue)
        .then(function(valid) {
            if(!valid) {
                $zipUpdateButton.prop('disabled', false);
                error($formParent, ZIP_ERROR_MESSAGES.DIGITS);
                return;
            }
            commonValidator.verifyZipCode(zipValue)
                .then(function(data) {
                    $zipUpdateButton.prop('disabled', false);
                    if(!data.isValid) {
                        error($formParent, ZIP_ERROR_MESSAGES.DEFAULT);
                        return;
                    }
                    var url = window.location.pathname + zcUtils.parseSearchWithZip(zipValue);
                    if(window.location.hash) {
                        url += window.location.hash;
                    }
                    window.location = url;
                })
                .catch(function() {
                    $zipUpdateButton.prop('disabled', false);
                    error($formParent, ZIP_ERROR_MESSAGES.DEFAULT);
                    return;
                });
        });
}

module.exports = {
    zipToggler: _zipToggler,
    submit: _submit,
    geolocation: _geolocation,
    zipCloser: _zipCloser
};


//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/zipcode-changer/zipcode-changer-event-handler.js
// module id = 139
// module chunks = 0 1 16 24 25